const toLocalDate = (value, moment) => {
    if (!value) {
        return null;
    }

    if (value instanceof Date) {
        return moment(value)
            .startOf('day')
            .toDate();
    }

    if (typeof value === 'string') {
        const parsedValue = moment(value, 'YYYY-MM-DD', true);
        if (parsedValue.isValid()) {
            return parsedValue.startOf('day').toDate();
        }
    }

    const fallbackDate = moment(value);
    if (!fallbackDate.isValid()) {
        return null;
    }

    return fallbackDate.startOf('day').toDate();
};

const getDaysArray = ([start, end], moment) => {
    const arr = [];
    if (!start) {
        return arr;
    }

    const startDate = toLocalDate(start, moment);
    const endDate = toLocalDate(end || start, moment);

    if (!startDate || !endDate || startDate > endDate) {
        return arr;
    }

    for (const dt = new Date(startDate); dt <= endDate; dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt));
    }

    return arr;
};

export { toLocalDate, getDaysArray };
